import { publicApi } from "./api"

export const newsService = {
    get: params => publicApi.get("/site/news/", { params }),
    getById: id => publicApi.get(`/site/news/${id}/`)
}


export const galleryService = {
    get: params => publicApi.get("/site/gallery/", {params}),
    getById: id => publicApi.get(`/site/gallery/${id}/`)
}


export const contactService = {
    get: params => publicApi.get("/site/contact_info/", {params}),
    getById: id => publicApi.get(`/site/contact_info/${id}/`)
}


export const bannerService = {
    get: params => publicApi.get("/site/banner/", {params})
}